import { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Input, Popconfirm, message } from 'antd';
import LangApi from '../api/langs';

const Langs = () => {
    const [langs, setLangs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingLang, setEditingLang] = useState(null);

    const fetchLangs = async () => {
        setLoading(true);
        try {
            const res = await LangApi.getAll();
            setLangs(res.data);
        } catch {
            message.error('Ошибка загрузки языков');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLangs();
    }, []);

    const openModal = (lang = null) => {
        setEditingLang(lang);
        setIsModalOpen(true);
        form.setFieldsValue(lang || { name: '', code: '' });
    };

    const closeModal = () => {
        setIsModalOpen(false);
        form.resetFields();
        setEditingLang(null);
    };

    const handleSubmit = async (values) => {
        try {
            if (editingLang) {
                await LangApi.update(editingLang.id, values);
                message.success('Язык обновлён');
            } else {
                await LangApi.create(values);
                message.success('Язык создан');
            }
            fetchLangs();
            closeModal();
        } catch {
            message.error('Ошибка сохранения');
        }
    };

    const handleDelete = async (id) => {
        try {
            await LangApi.remove(id);
            message.success('Удалено');
            fetchLangs();
        } catch {
            message.error('Ошибка удаления');
        }
    };

    const columns = [
        { title: 'Название', dataIndex: 'name', key: 'name' },
        { title: 'Код', dataIndex: 'code', key: 'code' },
        {
            title: 'Действия',
            key: 'actions',
            render: (_, record) => (
                <div className="flex gap-2">
                    <Button onClick={() => openModal(record)} size="small">Редактировать</Button>
                    <Popconfirm title="Удалить язык?" onConfirm={() => handleDelete(record.id)}>
                        <Button danger size="small">Удалить</Button>
                    </Popconfirm>
                </div>
            ),
        },
    ];

    return (
        <div>
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">Языки</h2>
                <Button type="primary" onClick={() => openModal()}>Добавить язык</Button>
            </div>

            <Table
                dataSource={langs}
                columns={columns}
                rowKey="id"
                loading={loading}
            />

            <Modal
                title={editingLang ? 'Редактировать язык' : 'Добавить язык'}
                open={isModalOpen}
                onCancel={closeModal}
                onOk={() => form.submit()}
                okText="Сохранить"
            >
                <Form form={form} layout="vertical" onFinish={handleSubmit}>
                    <Form.Item name="name" label="Название" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="code" label="Код" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default Langs;
